let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g7hw7")).then(() => parcelRequire('ky6h0'));